interface FancyTextProps {
  children: React.ReactNode
  className?: string
  style?: React.CSSProperties
  onClick?: () => void
}

export default function FancyText({
  children,
  className,
  style,
  onClick,
}: FancyTextProps) {
  return (
    <h3
      style={style}
      className={className}
      onClick={(e) => {
        e.preventDefault()
        onClick?.()
      }}
    >
      {children}
    </h3>
  )
}
